var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"container pb-2 header-intro login-header"},[_c('b-row',[_c('b-col',[[_c('img',{attrs:{"src":require("../../../../assets/icons/mysungevity/logo-sungevity-engie-white.svg")}})]],2)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }